module.exports = __webpack_public_path__ + "static/media/frog(16).1bc0c0fc.PNG";